import { Component } from '@angular/core';
import { SecurityPermissionName } from '@app/core/models/permission';
import { SubNavBaseComponent } from '@app/menu/components/sub-nav-base-component';

@Component({
  selector: 'portal-enterprise-phone-book-sub-nav',
  templateUrl: './enterprise-phone-book-sub-nav.component.html',
  standalone: false,
})
export class EnterprisePhoneBookSubNavComponent extends SubNavBaseComponent {
  Permission = SecurityPermissionName;
}
